var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgProgressIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 0H13L20 4V20H7L0 16V0Z",
  fill: "#A2C3F9"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.0001 6.25C7.92903 6.25 6.2501 7.92893 6.2501 10C6.2501 10.1023 6.25419 10.2036 6.2622 10.3038L6.87852 9.51492L7.66653 10.1306L6.36054 11.8022C6.19053 12.0198 5.87632 12.0583 5.65871 11.8883L3.98706 10.5824L4.6027 9.79434L5.25993 10.3078C5.25341 10.206 5.2501 10.1034 5.2501 10C5.2501 7.37665 7.37675 5.25 10.0001 5.25C11.4514 5.25 12.7511 5.90153 13.6217 6.92629L12.8595 7.57371C12.1709 6.76306 11.1457 6.25 10.0001 6.25Z",
  fill: "#004ECC"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M14.7403 9.69214L15.3975 10.2056L16.0131 9.41757L14.3415 8.1116C14.1239 7.9416 13.8097 7.98018 13.6397 8.19778L12.3337 9.86936L13.1217 10.485L13.738 9.69618C13.746 9.79633 13.7501 9.89765 13.7501 10C13.7501 12.0711 12.0712 13.75 10.0001 13.75C8.85453 13.75 7.82931 13.2369 7.14068 12.4263L6.37855 13.0737C7.24906 14.0985 8.54875 14.75 10.0001 14.75C12.6235 14.75 14.7501 12.6234 14.7501 10C14.7501 9.89662 14.7468 9.79397 14.7403 9.69214Z",
  fill: "#004ECC"
})));
export { SvgProgressIcon as ReactComponent };
export default __webpack_public_path__ + "assets/9a0e81f2.svg";